<template>
  <div>
    <!--  标题及按钮  -->
    <mtd-row>
      <mtd-col :span="12" class="height-full">
        <div class="page-title-32">{{ $getText('wenshu_web_export_application_record', '外发申请记录') }}</div>
      </mtd-col>
      <mtd-col :span="12" class="height-full text-right">
        <mtd-button type="primary" @click="back_to_file_out" style="margin-right: 0">{{ $getText('wenshu_web_file_export', '文件外发') }}</mtd-button>
      </mtd-col>
    </mtd-row>
    <!--  关键字检索  -->
    <mtd-row style="margin-top: 12px">
      <mtd-col :span="8">
        <mtd-input @enter="select_record_list" prefix-icon="mtdicon mtdicon-search" v-model="search_form.keyword"
                   :placeholder="$getText('wenshu_web_keyword_search', '关键字检索')" style="width: 100%;height: 32px"/>
      </mtd-col>
    </mtd-row>
    <!--  表格数据  -->
    <div style="margin-top: 12px">
      <mtd-table size="small" :data="file_out_apply_list" reserve-selection :empty-text="$getText('wenshu_web_no_data', '暂无数据')">
        <mtd-table-column type="expand" width="40">
          <template slot-scope="scope">
            <div style="padding: 12px 40px;background-color: #F7F7F7;">
              <div class="file-content-div">
                <h2 class="apply-content">{{ $getText('wenshu_web_included_files', '包含的文件') }}</h2>
                <div class="file-name">{{ scope.row.fileName }}</div>
              </div>
              <div class="file-content-div">
                <h2 class="apply-content">{{ $getText('wenshu_web_external_process', '外发流程') }}</h2>
                <div class="file-name">{{ scope.row.strategyName || $getText('wenshu_web_approval_free', '免审批') }}</div>
              </div>
              <div class="file-content-div">
                <h2 class="apply-content">{{ $getText('wenshu_web_external_reason', '外发原因') }}</h2>
                <div class="file-name">{{ scope.row.reason || $getText('wenshu_web_none', '无') }}</div>
              </div>
              <div class="file-content-div">
                <h2 class="apply-content">{{ $getText('wenshu_web_external_email', '外发邮箱') }}</h2>
                <div class="file-name">{{ scope.row.emails || $getText('wenshu_web_none', '无') }}</div>
              </div>
              <div class="file-content-div">
                <h2 class="apply-content">{{ $getText('wenshu_web_file_share_link', '文件分享链接') }}</h2>
                <div class="file-name"><a :href="scope.row.downloadUrl" target="_blank">{{ scope.row.downloadUrl }}</a>
                </div>
              </div>
              <div class="file-content-div">
                <h2 class="apply-content">{{ $getText('wenshu_web_extraction_password', '提取密码') }}</h2>
                <div class="file-name">{{ scope.row.downloadPassword || $getText('wenshu_web_none', '无') }}</div>
              </div>
            </div>
          </template>
        </mtd-table-column>
        <mtd-table-column prop="id" :label="$getText('wenshu_web_application_number', '申请编号')"/>
        <mtd-table-column prop="fileNumber" :label="$getText('wenshu_mobile_number_of_files', '文件数量')">
          <template slot-scope="scope">
            <span>{{ $getText('ws_mobile_file_count_unit', {count: scope.row.fileNum}, '{count}个文件') }}</span>
          </template>
        </mtd-table-column>
        <mtd-table-column prop="checkStatus" :label="$getText('wenshu_web_approval_status', '审批状态')">
          <template slot-scope="scope">
            <!-- 审批中-->
            <div v-if="scope.row.status == 0">
              <i class='mtdicon mtdicon-time-o'
                 style="color: #0A70F5;margin-right: 4px;font-size: 16px;vertical-align: middle;"></i>
              <span style="vertical-align: middle;">{{ $getText('wenshu_mobile_pending_approval', '审批中') }}</span>
            </div>
            <!-- 已通过-->
            <div v-if="scope.row.status == 1">
              <i class='mtdicon mtdicon-success-o'
                 style="color: #00b365;margin-right: 4px;font-size: 16px;vertical-align: middle;"></i>
              <span style="vertical-align: middle;">
                {{ $getText('wenshu_mobile_approved', '已通过') }} <span v-if="scope.row.outOfDate" style="color: rgba(0,0,0,0.24);">
                {{ $getText('wenshu_web_link_expired', '（链接已过期）') }}
              </span>
              </span>
            </div>
            <!-- 已驳回-->
            <div v-if="scope.row.status == 2">
              <i class='mtdicon mtdicon-error-o'
                 style="color: #f5483b;margin-right: 4px;font-size: 16px;vertical-align: middle;"></i>
              <span style="vertical-align: middle;">{{ $getText('wenshu_mobile_rejected', '已驳回') }}</span>
            </div>
          </template>
        </mtd-table-column>
        <mtd-table-column prop="createTime" :label="$getText('wenshu_mobile_application_time', '申请时间')"  width="150">
          <template slot-scope="scope">
            {{ scope.row.createTime|dateTimeFormat }}
          </template>
        </mtd-table-column>
        <mtd-table-column prop="operation" :label="$getText('wenshu_web_operation', '操作')" width="260">
          <template slot-scope="scope">
            <mtd-button type="text-primary" size="small" @click="renew_record(scope.row)" v-if="scope.row.outOfDate"
                        style="padding-right: 12px;margin:0;width:62px;text-align: left;">{{ $getText('wenshu_mobile_renewal', '续期') }}
            </mtd-button>
            <mtd-button type="text-primary" size="small" @click="copyUrl(scope.row)" v-else="scope.row.outOfDate"
                        v-clipboard:copy="copyMessage" v-clipboard:success="copySuccess" v-clipboard:error="copyError"
                        style="padding-right: 12px;margin:0">{{ $getText('ws_mobile_copy_share_link', '复制链接') }}
            </mtd-button>
            <mtd-button type="text-primary" size="small" @click="check_process(scope.row)"
                        style="padding-left: 0;padding-right: 0;margin-right: 0px"
                        :disabled="scope.row.bpmAddress == null || scope.row.bpmAddress === ''">
              {{ $getText('wenshu_mobile_approval_progress', '审批进度') }}
            </mtd-button>
          </template>
        </mtd-table-column>
      </mtd-table>
      <mtd-pagination v-if="search_form.total > 10" :total="search_form.total" :show-total="true"
                      :current-page.sync="search_form.currentPage" @change="select_record_list()"
                      size="small" style="text-align: right;margin-top: 12px"/>

      <!-- 续期 -->
      <mtd-modal :title="$getText('wenshu_mobile_renewal', '续期')" v-model="renew_record_modal" width="504px">
        <mtd-form :label-width="110" :model="renew_record_data">
          <mtd-form-item :label="$getText('wenshu_web_validity_period', '有效期')" style="margin-bottom: 0;">
            <mtd-select v-model="renew_record_data.validateDays" style="width: 360px" @change="validateDays_change">
              <mtd-option :value="day.value" :label="day.label" :key="'key_'+day.value" v-for="day in default_days"/>
              <mtd-option :value="-1" :label="$getText('wenshu_web_custom', '自定义')"/>
            </mtd-select>
          </mtd-form-item>
        </mtd-form>
        <div slot="footer" class="demo-modal-footer">
          <mtd-button @click="close_renew_record">{{ $getText('wenshu_mobile_cancel', '取消') }}</mtd-button>
          <mtd-button
            type="primary" @click="submit_renew_recorde">{{ $getText('ws_mobile_confirm', '确定') }}
          </mtd-button>
        </div>
      </mtd-modal>
      <!-- 自定义有效期 -->
      <mtd-modal :title="$getText('wenshu_web_custom_validity_period', '自定义有效期')" v-model="custom_validate_modal" width="40%">
        <mtd-form :rules="custom_validate_rule" :model="custom_form">
          <mtd-form-item :label="$getText('wenshu_web_validity_period', '有效期') + ':'" prop="custom_validate" :label-width="110">
            <mtd-input type="text" v-model="custom_form.custom_validate" style="width: 240px;"
                       :placeholder="$getText('wenshu_web_max_validity_period_30_days_please_enter_number_1_to_30', '请输入1～30以内的数字')"/>
            {{ $getText('ws_mobile_days', '天') }}
          </mtd-form-item>
        </mtd-form>
        <div slot="footer" class="demo-modal-footer">
          <mtd-button @click="close_custom_validate">{{ $getText('wenshu_mobile_cancel', '取消') }}</mtd-button>
          <mtd-button type="primary" @click="submit_custom_validate" :disabled="custom_validate_disabled">{{ $getText('ws_mobile_confirm', '确定') }}
          </mtd-button>
        </div>
      </mtd-modal>
    </div>
  </div>
</template>

<script>

import {mapActions} from "vuex";
import moment from "moment";

export default {
  name: "file_out_list",
  filters: {
    dateTimeFormat(dateTime) {
      return moment(dateTime)
        .utcOffset(480)
        .format('YYYY-MM-DD HH:mm:ss');
    },
  },
  data() {
    const validateCustomDays = (_rule, value, callback) => {
      if (!/^[0-9]*$/.test(value)) {
        return callback(new Error(this.$getText('wenshu_web_max_validity_period_30_days_please_enter_number_1_to_30', '请输入1～30以内的数字')));
      }
      if (value < 1 || value > 30) {
        return callback(new Error(this.$getText('wenshu_web_max_validity_period_30_days_please_enter_number_1_to_30', '请输入1～30以内的数字')));
      }
      return callback();
    }
    return {
      default_days: [
        {value: 3, label: this.$getText('wenshu_mobile_3_days', '3天')},
        {value: 7, label: this.$getText('wenshu_mobile_7_days', '7天')},
        {value: 30, label: this.$getText('wenshu_mobile_30_days', '30天')}
      ],
      search_form: {
        keyword: '',
        currentPage: 1,
        limit: 10,
        total: 0,
      },
      file_out_apply_list: [],
      currentPage: 1,
      copyMessage: '',
      renew_record_modal: false,
      renew_record_data: {
        id: null,
        validateDays: 3
      },
      custom_form: {
        custom_validate: null,
      },
      custom_validate_modal: false,
      custom_validate_rule: {
        custom_validate: [
          {validator: validateCustomDays, trigger: 'change'},
        ]
      },
    }
  },
  computed: {
    custom_validate_disabled() {
      if (!this.custom_form.custom_validate) {
        return true;
      }
      let custom_validate = parseInt(this.custom_form.custom_validate);
      if (custom_validate < 1 || custom_validate > 30) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.select_record_list();
  },
  methods: {
    ...mapActions([
      'queryFileOutRecordList',
      'submitRenewFileOutOrder',
    ]),
    select_record_list() {
      this.queryFileOutRecordList(this.search_form).then(res => {
        this.file_out_apply_list = res.data.items;
        this.search_form.total = res.data.total;
      })
    },
    copyUrl(row) {
      let url = row.downloadUrl;
      let password = row.downloadPassword;
      let info = this.$getText('ws_mobile_file_share_link_text', '文件分享链接：') + url + '\n' + this.$getText('ws_mobile_extraction_code', '提取码：') + password;
      this.copyMessage = info;
    },
    copySuccess() {
      this.$mtd.message({
        message: this.$getText('ws_mobile_copy_success_to_clipborad', '链接已复制到剪切板'),
        type: 'success',
      });
    },
    copyError() {
      this.$mtd.message({
        message: this.$getText('ws_mobile_copy_failed', '复制失败'),
        type: 'error',
      });
    },
    back_to_file_out() {
      this.$router.push({name: "file_outer_upload"});
    },
    check_process(row) {
      let url = row.bpmAddress;
      window.open(url);
    },
    renew_record(row) {
      this.renew_record_data.id = row.id;
      this.renew_record_modal = true;
    },
    close_renew_record() {
      this.renew_record_data = {
        id: null,
        validateDays: 3
      };
      this.renew_record_modal = false;
    },
    validateDays_change(val) {
      if (val === -1) {
        this.custom_validate_modal = true;
      } else {
        this.custom_validate_modal = false;
      }
    },
    close_custom_validate() {
      this.custom_validate_modal = false;
      this.custom_form.custom_validate = null;
      this.renew_record_data.validateDays = 3;
    },
    submit_custom_validate() {
      let insert = true;
      let custom_validate = this.custom_form.custom_validate;
      for (let i = 0; i < this.default_days.length; i++) {
        let tmp = this.default_days[i];
        if (tmp.value === custom_validate) {
          insert = false;
          break;
        }
      }
      if (insert) {
        this.default_days.push({value: custom_validate, label: custom_validate + '天'});
        this.renew_record_data.validateDays = custom_validate;
      }
      this.custom_validate_modal = false;
      this.custom_form.custom_validate = null;
    },
    submit_renew_recorde() {
      this.submitRenewFileOutOrder(this.renew_record_data).then(_res => {
        this.$mtd.message.success(this.$getText('wenshu_web_renewal_success', '续期成功'));
        this.select_record_list();
        this.close_renew_record();
      });
    }
  }
}
</script>

<style>
@import "../../../styles/reset_table.css";

.margin-bottom-0 {
  margin-bottom: 0;
}

h2.dd-page-title {
  font-size: 20px;
  color: rgba(0, 0, 0, 0.84);
  line-height: 32px;
  margin-bottom: 16px;
}

h2.apply-content {
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 12px;
}

.mtd-table-cell {
  font-size: 12px;
}

.mtd-table .mtd-table-expanded-cell {
  padding: 0 !important;
}

.mtd-table-expanded-cell > .mtd-table-cell {
  height: auto;
}

.file-name {
  font-size: 14px;
  margin-bottom: 8px;
}

.file-content-div {
  margin-bottom: 12px;
}

.mtd-btn-small {
  padding: 0;
}

.mtd-message {
  min-width: 20px;
  padding: 6px 16px;
}
</style>
